/**
 * Determine if specified element is in vertical writing mode or not.
 */
export function isElementVerticalWriting(element: Element): boolean {
    const writingMode = element.computedStyleMap
        ? element.computedStyleMap().get("writing-mode")?.toString()
        : window.getComputedStyle(element)?.writingMode;
    return !!writingMode?.includes("vertical");
}
